import { TipoVisibilidadePoligonoTerritorio } from 'graphql/types.generated'

export enum TerritorioMapaCamadasPanelTabEnum {
  ADICIONAR = 'ADICIONAR',
  LISTAR = 'LISTAR',
}

export interface TerritorioMapaCamadasFormModel {
  nome: string
  categoria: string
  descricao: string
  visibilidade: TipoVisibilidadePoligonoTerritorio
}
